<template>
  <div :id="id + '_controls'" class="cat-repeater-controls">
    <cat-repeater-child-marker
      v-if="incompleteMarker"
      :id="id"
      class="cell"
      :type="incompleteMarker.type"
      :marker-text="
        incompleteMarker.message
          ? incompleteMarker.message
          : resolveTxt('skin.error.incomplete', 'incomplete')
      "
    ></cat-repeater-child-marker>
    <a
      v-if="allowEdit"
      class="icon-pencil edit-item button simple small pn mrt"
      tabindex="0"
      :title="editButtonLabel"
      :data-button="editButtonLabel"
      :data-label="editButtonLabel"
      role="button"
      @click="handleEdit"
      @keyup.enter="handleEdit"
      >{{ editButtonLabel }}</a
    >
    <a
      v-if="allowDelete"
      class="icon-trash edit-item button simple small pn mrt"
      tabindex="0"
      :title="deleteButtonLabel"
      :data-button="deleteButtonLabel"
      :data-label="deleteButtonLabel"
      role="button"
      @click="handleDelete"
      @keyup.enter="handleDelete"
      >{{ deleteButtonLabel }}</a
    >
    <a
      v-if="allowView && !selected"
      class="icon-eye edit-item button simple small pn mrt"
      tabindex="0"
      :title="viewButtonLabel"
      :data-button="viewButtonLabel"
      :data-label="viewButtonLabel"
      role="button"
      @click="handleView"
      @keyup.enter="handleView"
      >{{ viewButtonLabel }}</a
    >
    <a
      v-if="allowView && selected"
      class="icon-eye-off edit-item simple button small pn mrt"
      tabindex="0"
      :title="doneButtonLabel"
      :data-button="doneButtonLabel"
      :data-label="doneButtonLabel"
      role="button"
      @click="handleDone"
      @keyup.enter="handleDone"
      >{{ doneButtonLabel }}</a
    >
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import CatRepeaterChildMarker from "@/components/catRepeaterChild/catRepeaterChildMarker.vue";
export default defineComponent({
  name: "CatRepeaterRecordControls",
  components: { CatRepeaterChildMarker },
  props: {
    allowEdit: [Boolean],
    allowDelete: [Boolean],
    allowView: [Boolean],
    selected: [Boolean],
    editButtonLabel: [String],
    deleteButtonLabel: [String],
    viewButtonLabel: [String],
    doneButtonLabel: [String],
    id: [String],
    incompleteMarker: {
      type: Object,
      default: null,
      description:
        "Contains the fields: message - the incomplete text, childIndex - to identify the child offscreen, type - styling class (i.e. errors, warning, info, debug)"
    }
  },
  methods: {
    handleDelete: function (event) {
      this.$emit("ui-repeater-delete", {
        event: event,
        id: this.id ? this.id : null
      });
    },
    handleEdit: function (event) {
      this.$emit("ui-repeater-edit", {
        event: event,
        id: this.id ? this.id : null
      });
    },
    handleView: function (event) {
      this.$emit("ui-repeater-view", {
        event: event,
        id: this.id ? this.id : null
      });
    },
    handleDone: function (event) {
      this.$emit("ui-repeater-done", {
        event: event,
        id: this.id ? this.id : null
      });
    }
  }
});
</script>
